import { Grid } from '@mui/material'
import { BookingSearchRequestData } from 'api/models/BookingSearch'

import BookingTable from 'components/Bookings/BookingTable/BookingTable'
import SearchBar from 'components/Bookings/BookingTable/SearchBar'
import useDebounce from 'hooks/useDebounce'
import BaseLayout from 'layouts/Base/BaseLayout'
import { DateTime } from 'luxon'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import AmendModal from '../AmendModal/ViewAmendModal'

const BookingsPage = () => {
  const defaultClient = useSelector((state: any) => state.clients.client)
  const defaultSearch: BookingSearchRequestData = {
    clientName: defaultClient.companyName,
    when: {
      from: DateTime.now().startOf('day').toString(),
      to: DateTime.now().plus({ years: 2 }).toString(),
    },
    orderBy: {
      isDescending: false,
      bookingOrderByTypeName: 'When',
    },
  }
  const [searchOptions, setSearchOptions] =
    React.useState<BookingSearchRequestData>(defaultSearch)
  const debouncedSearch = useDebounce(searchOptions, 600)
  const location = useLocation()
  const history = useHistory()

  // Check for ?bookingId=123 query param to auto-open the modal
  const queryBookingId = new URLSearchParams(location.search).get('bookingId')
  const [bookingId, setBookingId] = useState(() => {
    const id = parseInt(queryBookingId || '0', 10)
    return Number.isFinite(id) ? id : 0
  })
  const debouncedBookingId = useDebounce(bookingId, 600)

  const [openModal, setOpenModal] = useState(false)

  // Auto-open modal from query param on mount
  useEffect(() => {
    if (queryBookingId) {
      history.replace(location.pathname)
    }
  }, [])

  useEffect(() => {
    if (bookingId !== 0) {
      setOpenModal(true)
    }
  }, [debouncedBookingId, bookingId])

  return (
    <BaseLayout
      pageTitle="Bookings"
      pageSubtitle="Your Travel Information"
      wideElement={
        <Grid container sx={{ marginTop: '30px' }}>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12}>
                <SearchBar
                  defaultSearch={defaultSearch}
                  defaultClient={defaultClient}
                  updateSearch={setSearchOptions}
                />
              </Grid>
              <Grid item xs={12}>
                <BookingTable
                  searchOptions={debouncedSearch}
                  setBookingId={setBookingId}
                  openModal={openModal}
                  returnOpenModal={setOpenModal}
                />
              </Grid>
            </Grid>
          </Grid>
          <AmendModal
            openViewEditModal={openModal}
            setOpenViewEditModal={setOpenModal}
            selectedBookingId={bookingId}
            setBookingId={setBookingId}
          ></AmendModal>
        </Grid>
      }
    />
  )
}
export default BookingsPage
